import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { SessionService } from "./session.service";
import { IResponseAPIObjeto } from "@models/responseAPI.interface";
import { DangerError } from "@shared/errors/custom.error";

@Injectable({
    providedIn: "root",
})
export class NotificacionService {
    rutSinDV: number; // Rut del usuario sin su digito verificador

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService
    ) {
        this.rutSinDV = this.sessionService.getSesionActual().getRutSinDV();
    }

    async generarNotificacion(
        numeroExpediente: number,
        tipoNotificacion: number,
        archivoUrl?: string
    ) {
        const payload: any = {
            numero_expediente: numeroExpediente,
            tipo_notificacion: tipoNotificacion,
        };

        if (archivoUrl) {
            payload.archivo = archivoUrl;
        }

        // Lo tratamos como 'any' para poder leer 'ok' y 'message' si vienen
        const response: any = await this.apiService.privatePost(
            `crear-notificacion`,
            payload
        );

        // Verificamos si viene 'success' o si viene 'ok'
        const isSuccess = response.success !== undefined ? response.success : response.ok;
        // Verificamos si viene 'msg' o si viene 'message'
        const mensajeRespuesta = response.msg || response.message || "Operación realizada";

        // Si falló, lanzamos el error
        if (!isSuccess) throw new DangerError(mensajeRespuesta);

        // Si todo salió bien, devolvemos el mensaje
        return mensajeRespuesta;
    }
}